import enquire from 'enquire-js';
import { toggleClass, toggleAttribute } from '../helpers';

const narrowMenu = document.querySelector('.primary-menu-narrow');
const subMenuParents = narrowMenu.querySelectorAll('.menu-item-has-children > a');

/**
 * Toggle sub menus open
 */
function toggleSubMenu(e) {
	e.preventDefault();

	const closestMenuItem = e.target.closest('.menu-item');
	const closestSubMenu = e.target.closest('.menu-item').querySelector('.sub-menu');

	// if any sub-menus are already open, close them before opening a new one
	toggleClass(closestMenuItem, '-open');
	toggleClass(closestSubMenu, '-open');
	toggleAttribute(closestSubMenu, 'aria-hidden');
	toggleAttribute(this, 'aria-expanded');
}

/**
 * Setup pre-interaction state with aria roles on parents/children
 * if <li> has children, add aria-haspopup and aria hidden
 */
function setInitialMenuState() {
	const parents = narrowMenu.querySelectorAll('.menu-item-has-children > a');
	const subMenus = narrowMenu.querySelectorAll('.menu-item-has-children .sub-menu');

	parents.forEach(parent => {
		const button = document.createElement('button');

		button.innerHTML = parent.innerHTML;
		button.setAttribute('class', 'submenu-toggle');
		button.setAttribute('aria-haspopup', 'true');
		button.setAttribute('aria-expanded', 'false');

		/**
		 * Listen for clicks on sub menu parent items
		 */
		button.addEventListener('click', toggleSubMenu);

		parent.parentNode.replaceChild(button, parent);
	});

	subMenus.forEach(subMenu => {
		subMenu.setAttribute('aria-hidden', 'true');
	});
}

/**
 * Kick things off
 */
setInitialMenuState();

/**
* Fix button focus outlines.
*/
window.wdsButtonFocusFix = {};
(function (window, app) {

	// Private variable.
	var mouseActive = false;

	// Constructor.
	app.init = function () {
		app.cache();

		if (app.meetsRequirements()) {
			app.bindEvents();
		}
	};

	// Cache all the things.
	app.cache = function () {
		app.$c = {
			buttons: document.querySelectorAll('.primary-navigation-narrow button, .hamburger-toggle'),
		};
	};

	// Combine all events.
	app.bindEvents = function () {
		for (const button of app.$c.buttons) {
			button.addEventListener('mousedown', app.handleButtonMousedown);
			button.addEventListener('focus', app.handleButtonFocus);
			button.addEventListener('blur', app.handleButtonBlur);
		}
	};

	// Do we meet the requirements?
	app.meetsRequirements = function () {
		return app.$c.buttons.length;
	};

	// Handle Button Mousedown event.
	app.handleButtonMousedown = function () {
		mouseActive = true;

		window.setTimeout(function () {
			mouseActive = false;
		}, 100);
	};

	// Handle Button Focus event.
	app.handleButtonFocus = function () {
		if (!mouseActive) {
			this.classList.add('md-focused');
		}
	};

	// Handle Button Blur event.
	app.handleButtonBlur = function () {
		this.classList.remove('md-focused');
	};

	// Engage!
	app.init();

}(window, window.wdsButtonFocusFix));
